<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card header-class="redmfu">
            <div slot="header">
              <strong v-if="student.thaistudent==1">ยืนยันการติดต่อขอรับปริญญาบัตร</strong>
              <strong v-else>The way to obtain Certificate</strong>
              <div style="float:right;">
                <b-badge pill variant="warning" class="font-sm text-dark p-2 pr-3 pl-3">Session Timeout :
                  {{ this.$store.state.timeExp }}
                </b-badge>
              </div>
            </div>
            <div v-if="current_paid==1" align="center"><br>
              <font color="green" v-if="student.thaistudent==1"><strong>สถานะ: ชำระเงินแล้ว<br></strong></font>
              <font color="green" v-if="student.thaistudent==0"><strong>Status: Paid already<br></strong></font>
              <font color="#00008b">
                <br>กรณีชำระค่าธรรมเนียมการจัดส่งปริญญาบัตรแล้ว แต่ได้ดำเนินการเปลี่ยนแปลงเป็นเข้ารับพระราชทานปริญญาบัตร
                <br>จะไม่สามารถคืนค่าธรรมเนียมการส่งไปรษณีย์ได้
              </font>
              <br>
              <font color="red">
                <br>ส่วนทะเบียนและประมวลผล จะดำเนินการจัดส่งให้ทางไปรษณีย์
                <br>หลังเสร็จพิธีพระราชทานปริญญาบัตร ภายใน 7 วันทำการ
                <br><u>หมายเหตุ</u> : สามารถตรวจสอบหมายเลขไปรษณีย์การจัดส่งปริญญาบัตร ได้ที่ระบบเอกสารทางการศึกษา <a href="https://regdoc.mfu.ac.th"  target="_blank">(https://regdoc.mfu.ac.th)</a> เมนูการขอเอกสาร
                <br>
                <font color="#00008b">
                  <br>If you have already paid the fee for mailing but later changed to attend the commencement ceremony, the fee is non-refundable.
                  <br>
                </font>
                <br>The Registrar Division will send the degree certificate by post,
                <br>after the commencement ceremony is finished within 7 working days.
                <br><u>Remarks</u> : You can check the tracking number via the e-Academic Document <a href="https://regdoc.mfu.ac.th"  target="_blank">(https://regdoc.mfu.ac.th)</a>, Request Document menu.
              </font>
<!--              <font color="red">-->
<!--                ส่วนทะเบียนและประมวลผล จะดำเนินการจัดส่งให้ทางไปรษณีย์-->
<!--                <br>หลังเสร็จพิธีพระราชทานปริญญาบัตร ภายใน 7 วันทำการ-->
<!--                <br><br>The Registrar Division will send the degree certificate by post,-->
<!--                <br>after the commencement ceremony is finished within 7 working days.</font>-->
            </div>
            <b-form-group label-cols-sm="1" label label-align-sm="right" label-for="nested-street"
                          v-if="current_paid==0">
              <b-form-radio-group v-model="selected_post"
                                  value-field="BYTECODE"
                                  text-field="BYTEDES"
                                  :options="items"
                                  stacked
                                  name="selected_post"
              ></b-form-radio-group>
              <div
                v-if="student.thaistudent==0&& (selected_post==20||selected_post==21||selected_post==22||selected_post==31)">
                &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp-Domestic
              </div>
              <div v-if="selected_post==20 || selected_post==21 || selected_post==22||selected_post==31">
                <b-form-group
                  label-cols-sm="1"
                  label
                  label-align-sm="right"
                  label-for="nested-street">
                  <b-form-radio-group v-model="selected_post"
                                      value-field="BYTECODE"
                                      text-field="BYTEDES"
                                      :options="items1"
                                      stacked
                                      name="selected_post1"
                  >
                  </b-form-radio-group>
                </b-form-group>
              </div>
              <div
                v-if="student.thaistudent==0 && (selected_post==20||selected_post==21||selected_post==22||selected_post==31)">
                &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                -Overseas
              </div>
              <b-form-group
                label-cols-sm="1"
                label
                label-align-sm="right"
                label-for="nested-street"
                v-if="(selected_post==20||selected_post==21||selected_post==22||selected_post==31)"
              >
                <b-form-radio-group
                  v-if="student.thaistudent==0"
                  v-model="selected_post"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items2"
                  stacked
                  name="selected_post2"
                ></b-form-radio-group>
              </b-form-group>
              <br>
              <div v-if="selected_post=='12' ">
                <label class="mr-sm-2" v-if="student.thaistudent==1">ระบุชื่อ-นามสกุลผู้รับมอบ</label>
                <label class="mr-sm-2" v-if="student.thaistudent==0">Authorized person name</label>
                <b-form-input
                  id="current_authorized"
                  type="text"
                  autocomplete="current_authorized"
                  v-model="current_authorized"
                  placeholder="Authorized person name..."
                ></b-form-input>
              </div>
              <!-- select: {{ selected_post }}  -->
            </b-form-group>

            <div v-if="selected_post=='11' || selected_post=='12'" align="center">
              <font color="red">แสดงหนังสือยืนยันการขอรับปริญญาบัตร พร้อมบัตรประจำตัวนักศึกษาหรือบัตรประจำตัวประชาชน
                <br>หรือหนังสือเดินทาง ต่อเจ้าหน้าที่เพื่อติดต่อขอรับปริญญาบัตร
                <br>ได้ที่ส่วนทะเบียนและประมวลผล ตั้งแต่วันที่ 19 มีนาคม พ.ศ. 2568 เวลา 9.00 น. เป็นต้นไป
                <br>สอบถามข้อมูลเกี่ยวกับการขอรับปริญญา เบอร์ติดต่อ 053 916433/ 053- 916546 /053-916547


                <br><br>Please show a confirmation letter for obtaining a degree certificate
                <br>with student ID card or passport to the staff for contacting to obtain a degree certificate
                <br>at the registrar division after March 19,2025 at 9:00 a.m. onwards.
                <br>For more information about a degree certificate,
                <br>contact number 053-916433 / 053-916546 / 053-916547.


              </font>
            </div>
            <div
              v-if="(selected_post=='20' ||selected_post=='21' || selected_post=='22' || selected_post=='31' )&& current_paid==0"
              align="center">
              <font color="#00008b">
                <br>กรณีชำระค่าธรรมเนียมการจัดส่งปริญญาบัตรแล้ว แต่ได้ดำเนินการเปลี่ยนแปลงเป็นเข้ารับพระราชทานปริญญาบัตร
                <br>จะไม่สามารถคืนค่าธรรมเนียมการส่งไปรษณีย์ได้
              </font>
              <br>
              <font color="red">
                <br>ส่วนทะเบียนและประมวลผล จะดำเนินการจัดส่งให้ทางไปรษณีย์
                <br>หลังเสร็จพิธีพระราชทานปริญญาบัตร ภายใน 7 วันทำการ
                <br><u>หมายเหตุ</u> : สามารถตรวจสอบหมายเลขไปรษณีย์การจัดส่งปริญญาบัตร ได้ที่ระบบเอกสารทางการศึกษา <a href="https://regdoc.mfu.ac.th"  target="_blank">(https://regdoc.mfu.ac.th)</a> เมนูการขอเอกสาร
                <br>
                <font color="#00008b">
                <br>If you have already paid the fee for mailing but later changed to attend the commencement ceremony, the fee is non-refundable.
                  <br>
                </font>
                <br>The Registrar Division will send the degree certificate by post,
                <br>after the commencement ceremony is finished within 7 working days.
                <br><u>Remarks</u> : You can check the tracking number via the e-Academic Document <a href="https://regdoc.mfu.ac.th"  target="_blank">(https://regdoc.mfu.ac.th)</a>, Request Document menu.
              </font>
            </div>
            <div slot="footer" class="text-center"
                 v-if="(selected_post=='11' || selected_post=='12' )&& current_paid==0">
              <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onSubmit">
                <!--                @click="onSubmit"-->
                <i class="fa fa-dot-circle-o"></i> Submit
              </b-button>
              <b-button type="reset" size="md" class="mr-2" variant="danger" v-if="current_paid==0">
                <i class="fa fa-ban"></i> Reset
              </b-button>
            </div>
          </b-card>


          <b-card v-if="(selected_post ==21 || selected_post==22)&& current_paid==0" header-class="redmfu">
            <div slot="header" v-if="student.thaistudent==1">
              <strong>ที่อยู่ในการจัดส่ง</strong>
            </div>
            <div slot="header" v-if="student.thaistudent==0" header-class="redmfu">
              <strong>Address</strong>
            </div>
            <b-row>
              <b-col sm="6">
                <b-form-group label="ชื่อ" :label-cols="4" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_name"
                    type="text"
                    autocomplete="current_name"
                    v-model="current_name"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Name" :label-cols="4" v-else>
                  <b-form-input
                    id="current_name"
                    type="text"
                    autocomplete="current_name"
                    v-model="current_name"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="นามสกุล" :label-cols="2" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_surname"
                    type="text"
                    autocomplete="current_surname"
                    v-model="current_surname"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Surname" :label-cols="2" v-else>
                  <b-form-input
                    id="current_surname"
                    type="text"
                    autocomplete="current_surname"
                    v-model="current_surname"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="จังหวัด" :label-cols="4" v-if="student.thaistudent==1">
                  <b-form-select
                    value-field="PROVINCE_ID"
                    text-field="PROVINCENAME"
                    size="md"
                    :plain="true"
                    :options="provinceItems"
                    v-model="select_province"
                    v-on:change="selectProvinceOnchange"
                  ></b-form-select>
                </b-form-group>
                <b-form-group label="Province" :label-cols="4" v-else>
                  <b-form-select
                    value-field="PROVINCE_ID"
                    text-field="PROVINCENAME"
                    size="md"
                    :plain="true"
                    :options="provinceItems"
                    v-model="select_province"
                    v-on:change="selectProvinceOnchange"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="อำเภอ" :label-cols="2" v-if="student.thaistudent==1">
                  <b-form-select
                    value-field="DISTRICTID"
                    text-field="DISTRICTNAME"
                    class="mb-3"
                    :plain="true"
                    :options="districtItems"
                    v-model="select_district"
                    v-on:change="selectDistrictOnchange"
                  ></b-form-select>
                </b-form-group>
                <b-form-group label="District" :label-cols="2" v-else>
                  <b-form-select
                    value-field="DISTRICTID"
                    text-field="DISTRICTNAME"
                    class="mb-3"
                    :plain="true"
                    :options="districtItems"
                    v-model="select_district"
                    v-on:change="selectDistrictOnchange"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="ตำบล" :label-cols="4" v-if="student.thaistudent==1">
                  <b-form-select
                    value-field="SUB_DISTRICTID"
                    text-field="SUB_DISTRICTNAME"
                    size="md"
                    :plain="true"
                    :options="subdistrictItems"
                    v-model="select_subdistrict"
                    v-on:change="selectSubDistrictOnchange"
                  ></b-form-select>
                </b-form-group>
                <b-form-group label="Subdistrict" :label-cols="4" v-else>
                  <b-form-select
                    value-field="SUB_DISTRICTID"
                    text-field="SUB_DISTRICTNAME"
                    size="md"
                    :plain="true"
                    :options="subdistrictItems"
                    v-model="select_subdistrict"
                    v-on:change="selectSubDistrictOnchange"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="รหัสไปรษณีย์" :label-cols="2" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_zipcode"
                    type="text"
                    autocomplete="current_zipcode"
                    v-model="current_zipcode"
                  ></b-form-input>
                  <!--                  readonly-->
                </b-form-group>
                <b-form-group label="Postcode" :label-cols="2" v-else>
                  <b-form-input
                    id="current_zipcode"
                    type="text"
                    autocomplete="current_zipcode"
                    v-model="current_zipcode"
                  ></b-form-input>
                  <!--                  readonly-->
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="บ้านเลขที่" :label-cols="4" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_add"
                    type="text"
                    autocomplete="current_add"
                    v-model="current_add"
                    :state="validation_no"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_no">
                    Your Number must be 1-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_no">
                    Correct.
                  </b-form-valid-feedback>
                </b-form-group>
                <b-form-group label="Address number" :label-cols="4" v-else>
                  <b-form-input
                    id="current_add"
                    type="text"
                    autocomplete="current_add"
                    v-model="current_add"
                    :state="validation_no"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_no">
                    Your Number must be 3-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_no">
                    Correct.
                  </b-form-valid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="หมู่" :label-cols="2" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_moo"
                    type="text"
                    autocomplete="current_moo"
                    v-model="current_moo"
                    :state="validation_moo"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_moo">
                    Your Number must be 1-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_moo">
                    Correct.
                  </b-form-valid-feedback>
                </b-form-group>
                <b-form-group label="Moo" :label-cols="2" v-else>
                  <b-form-input
                    id="current_moo"
                    type="text"
                    autocomplete="current_moo"
                    v-model="current_moo"
                    :state="validation_moo"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_moo">
                    Your Number must be 1-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_moo">
                    Correct.
                  </b-form-valid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="หมู่บ้าน" :label-cols="4" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_village"
                    type="text"
                    autocomplete="current_village"
                    v-model="current_village"
                    :state="validation_village"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_village">
                    Your Number must be 3-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_village">
                    Correct.
                  </b-form-valid-feedback>
                </b-form-group>
                <b-form-group label="Village" :label-cols="4" v-else>
                  <b-form-input
                    id="current_village"
                    type="text"
                    autocomplete="current_village"
                    v-model="current_village"
                    :state="validation_village"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_village">
                    Your Number must be 3-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_village">
                    Correct.
                  </b-form-valid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="อาคาร/ตึก" :label-cols="2" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_building"
                    type="text"
                    autocomplete="current_building"
                    v-model="current_building"
                    :state="validation_build"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_build">
                    Your Number must be 1-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_build">
                    Correct.
                  </b-form-valid-feedback>
                </b-form-group>
                <b-form-group label="Building" :label-cols="2" v-else>
                  <b-form-input
                    id="current_building"
                    type="text"
                    autocomplete="current_building"
                    v-model="current_building"
                    :state="validation_build"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_build">
                    Your Soi must be 1-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_build">
                    Correct.
                  </b-form-valid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="ซอย" :label-cols="4" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_lane"
                    type="text"
                    autocomplete="current_lane"
                    v-model="current_lane"
                    :state="validation_soi"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_soi">
                    Your Soi must be 1-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_soi">
                    Correct.
                  </b-form-valid-feedback>
                </b-form-group>
                <b-form-group label="Soi" :label-cols="4" v-else>
                  <b-form-input
                    id="current_lane"
                    type="text"
                    autocomplete="current_lane"
                    v-model="current_lane"
                    :state="validation_soi"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_soi">
                    Your Soi must be 1-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_soi">
                    Correct.
                  </b-form-valid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="ถนน" :label-cols="2" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_road"
                    type="text"
                    autocomplete="current_road"
                    v-model="current_road"
                    :state="validation_road"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_road">
                    Your Road must be 1-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_road">
                    Correct.
                  </b-form-valid-feedback>
                </b-form-group>
                <b-form-group label="Road" :label-cols="2" v-else>
                  <b-form-input
                    id="current_road"
                    type="text"
                    autocomplete="current_road"
                    v-model="current_road"
                    :state="validation_road"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_road">
                    Your Road must be 1-50 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_road">
                    Correct.
                  </b-form-valid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="โทรศัพท์มือถือ(ปัจจุบัน)" :label-cols="4"
                              v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_tel"
                    type="text"
                    autocomplete="current_tel"
                    v-model="current_tel"
                    :state="validation_tel"
                  >{{ current_tel }}
                  </b-form-input>
                </b-form-group>
                <b-form-group label="Mobile" :label-cols="4" v-else>
                  <b-form-input
                    id="current_tel"
                    type="text"
                    autocomplete="current_tel"
                    v-model="current_tel"
                    :state="validation_tel"
                  >{{ current_tel }}
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="โทรศัพท์บ้าน" :label-cols="2" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_tel_home"
                    type="text"
                    autocomplete="current_tel_home"
                    v-model="current_tel_home"
                    :state="validation_home"
                  >{{ current_tel_home }}
                  </b-form-input>
                </b-form-group>
                <b-form-group label="Home Phone" :label-cols="2" v-else>
                  <b-form-input
                    id="current_tel_home"
                    type="text"
                    autocomplete="current_tel_home"
                    v-model="current_tel_home"
                    :state="validation_home"
                  >{{ current_tel_home }}
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Fax" :label-cols="4">
                  <b-form-input
                    id="current_fax"
                    type="text"
                    autocomplete="current_fax"
                    v-model="current_fax"
                    :state="validation_fax"
                  >{{ current_fax }}
                  </b-form-input>
                </b-form-group>

              </b-col>
              <b-col sm="6">
                <b-form-group label="Email" :label-cols="2">
                  <b-form-input
                    id="current_email"
                    type="text"
                    autocomplete="current_email"
                    v-model="current_email"
                    :state="validation_email"
                  >{{ current_email }}
                  </b-form-input>
                </b-form-group>

              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Facebook" :label-cols="4">
                  <b-form-input
                    id="current_fb"
                    type="text"
                    autocomplete="current_fb"
                    v-model="current_fb"
                  >{{ current_fb }}
                  </b-form-input>
                </b-form-group>

              </b-col>
            </b-row>
            <div slot="footer" class="text-center" v-if="current_paid==0">
              <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onSubmit">
                <i class="fa fa-dot-circle-o"></i> Submit
              </b-button>

              <b-button type="reset" size="md" class="mr-2" variant="danger" v-if="current_paid==0">
                <i class="fa fa-ban"></i> Reset
              </b-button>
            </div>
          </b-card>
          <b-card v-if="student.thaistudent==0 && selected_post==31" header-bg-variant=primary>
            <div slot="header" v-if="student.thaistudent==1">
              <strong>ที่อยู่ในการจัดส่ง</strong>
            </div>
            <div slot="header" v-if="student.thaistudent==0">
              <strong>Address</strong>
            </div>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Country" :label-cols="4">
                  <!-- <b-form-select
                      id="select_country"
                      value-field="COUNTRYID"
                      text-field="COUNTRYNAME"
                      v-model="select_country"
                      :plain="true"
                      :options="countryItems"
                      v-on:change="selectCountryOnchange"
                      return-object
                  ></b-form-select> -->
                  <v-select
                    label="COUNTRYNAME"
                    :options="countryItems"
                    v-model="select_country1"
                    @input="selectCountryOnchange"
                  ></v-select>
                  <!-- <div  >{{ select_country1 }}</div> -->
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="6">
                <b-form-group label="Name" :label-cols="4">
                  <b-form-input
                    id="current_name"
                    type="text"
                    autocomplete="current_name"
                    v-model="current_name"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Surname" :label-cols="2">
                  <b-form-input
                    id="current_surname"
                    type="text"
                    autocomplete="current_surname"
                    v-model="current_surname"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Adress" :label-cols="2">
                  <b-form-input
                    id="current_add"
                    type="text"
                    autocomplete="current_add"
                    v-model="current_add"
                  >{{ current_add }}
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Mobile" :label-cols="4">
                  <b-form-input
                    id="current_tel"
                    type="text"
                    autocomplete="current_tel"
                    v-model="current_tel"
                    :state="validation_tel"
                  >{{ current_tel }}
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="โทรศัพท์บ้าน" :label-cols="2" v-if="student.thaistudent==1">
                  <b-form-input
                    id="current_tel_home"
                    type="text"
                    autocomplete="current_tel_home"
                    v-model="current_tel_home"
                    :state="validation_home"
                  >{{ current_tel_home }}
                  </b-form-input>
                </b-form-group>
                <b-form-group label="Home Phone" :label-cols="2" v-else>
                  <b-form-input
                    id="current_tel_home"
                    type="text"
                    autocomplete="current_tel_home"
                    v-model="current_tel_home"
                    :state="validation_home"
                  >{{ current_tel_home }}
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Fax" :label-cols="4">
                  <b-form-input
                    id="current_fax"
                    type="text"
                    autocomplete="current_fax"
                    v-model="current_fax"
                  >{{ current_fax }}
                  </b-form-input>
                </b-form-group>

              </b-col>
              <b-col sm="6">
                <b-form-group label="Email" :label-cols="2">
                  <b-form-input
                    id="current_email"
                    type="text"
                    autocomplete="current_email"
                    v-model="current_email"
                    :state="validation_email"
                  >{{ current_email }}
                  </b-form-input>
                </b-form-group>

              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Facebook" :label-cols="4">
                  <b-form-input
                    id="current_fb"
                    type="text"
                    autocomplete="current_fb"
                    v-model="current_fb"
                  >{{ current_fb }}
                  </b-form-input>
                </b-form-group>

              </b-col>

            </b-row>
            <div slot="footer" class="text-center" v-if="current_paid==0">
              <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onSubmit">
                <i class="fa fa-dot-circle-o"></i> Submit
              </b-button>

              <b-button type="reset" size="md" class="mr-2" variant="danger" v-if="current_paid==0">
                <i class="fa fa-ban"></i> Reset
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>
    <b-modal v-if="student.thaistudent==1"
             title="คุณกรอกข้อมูลไม่ครบถ้วน"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>


    <b-modal v-if="student.thaistudent==0"
             title="You didn’t fill your information completely"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>

    <!--    <b-modal v-if="student.thaistudent==1"-->
    <!--             title="การชำระเงิน (Payment)"-->
    <!--             class="modal-danger"-->
    <!--             v-model="dangerModalPayment"-->
    <!--             @click="dangerModalPayment = false"-->
    <!--             ok-variant="danger"-->
    <!--    >-->


    <!--      {{ current_paymenttxt }} @ok="dangerModalPayment = false"-->
    <!--    </b-modal>-->


  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {YimoVueEditor},
  name: "CreateGeneral",
  data() {
    return {
      student: {},
      std_id: "",
      sex: "",
      thai_student: "",
      numEror: 0,
      current_erorrtxt: "",
      current_paymenttxt: "",
      selected_post: "",
      selected_post1: "",
      selected_post2: "",
      other_txt: "",
      dangerModal: false,
      items: [],
      items1: [],
      items2: [],
      actionUpdate: 10,
      actionStudent: 10,
      levelid: "",
      q1: "",
      q2: "",
      q3: "",
      q4: "",
      select_country: "",
      select_country1: "",
      select_province: 0,
      provinceItems: [],
      select_district: 0,
      districtItems: [],
      select_subdistrict: 0,
      subdistrictItems: [],
      countryItems: [],
      current_tel: "",
      current_tel_home: "",
      current_add: "",
      current_village: "",
      current_moo: "",
      current_lane: "",
      current_road: "",
      current_zipcode: "",
      current_building: "",
      current_province: "",
      current_province_name: "",
      current_district: "",
      current_district_name: "",
      current_subdistrict: "",
      current_subdistrict_name: "",
      current_name: "",
      current_surname: "",
      current_country: "",
      current_country_name: "",
      current_fax: "",
      current_email: "",
      current_authorized: "",
      current_fb: "",
      current_year: "",
      current_paid: 0,
    };
  },
  components: {
    vSelect
  },
  computed: {
    validation_email(){
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const thaiCharRegex = /[ก-ฮ]/;
      if (this.current_email!=null && this.current_email!='' && this.current_email!=undefined) {
        if (!emailRegex.test(this.current_email)) {
          return false;
        } else if (thaiCharRegex.test(this.current_email)) {
          return false;
        } else {
          return true;
        }
      }else{
        return false;
      }
    },
    validation_home() {
      // fax มี - ได้
      var substring = "-";
      var spacestring = " ";
      var zerochar = "00000";
      if (this.current_tel_home != null && this.current_tel_home != '' && this.current_tel_home != undefined) {
        if (this.current_tel_home == "-") {
          return true;
        }
        // console.log("select_country===", this.select_country)
        if (this.current_country == 41) {
          if (this.current_tel_home.toString().length >= 9) {
            if ((this.current_tel_home.toString().includes(substring)) || (this.current_tel_home.toString().includes(spacestring)) || (this.current_tel_home.toString().includes(zerochar))) {
              return false;
            } else {
              if (this.current_tel_home.toString().length > 0) {
                if (this.validFax(this.current_tel_home)) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            }
          } else {
            return false;
          }
        } else {
          if (this.current_tel_home.toString().length >= 9 && this.current_tel_home.toString().length <= 30) {
            if ((this.current_tel_home.toString().includes(spacestring)) || (this.current_tel_home.toString().includes(zerochar))) {
              // console.log("substring");
              return false;
            } else {
              if (this.current_tel_home.toString().length > 0) {
                // console.log("this.validPhone() ==", this.validFax(this.current_fax));
                if (this.validFax(this.current_tel_home)) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            }
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    },
    validation_fax() {
      // fax มี - ได้
      var substring = "-";
      var spacestring = " ";
      var zerochar = "00000";
      if (this.current_fax != null && this.current_fax != '' && this.current_fax != undefined) {
        if (this.current_fax == "-") {
          return true;
        }
        // console.log("select_country===", this.select_country)
        if (this.current_country == 41) {
          if (this.current_fax.toString().length >= 9) {
            if ((this.current_fax.toString().includes(substring)) || (this.current_fax.toString().includes(spacestring)) || (this.current_fax.toString().includes(zerochar))) {
              return false;
            } else {
              if (this.current_fax.toString().length > 0) {
                if (this.validFax(this.current_fax)) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            }
          } else {
            return false;
          }
        } else {
          if (this.current_fax.toString().length >= 9 && this.current_fax.toString().length <= 30) {
            if ((this.current_fax.toString().includes(spacestring)) || (this.current_fax.toString().includes(zerochar))) {
              // console.log("substring");
              return false;
            } else {
              if (this.current_fax.toString().length > 0) {
                // console.log("this.validPhone() ==", this.validFax(this.current_fax));
                if (this.validFax(this.current_fax)) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            }
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    },
    validation_tel() {
      var substring = "-";
      var spacestring = " ";
      var zerochar = "00000";
      if (this.current_tel != null && this.current_tel != '' && this.current_tel != undefined) {
        if (this.current_country == 41) {
          if (this.current_tel.toString().length == 10 || this.current_tel.toString().length == 9) {
            if ((this.current_tel.toString().includes(substring)) || (this.current_tel.toString().includes(spacestring)) || (this.current_tel.toString().includes(zerochar))) {
              return false;
            } else {
              // console.log("this.validPhone() ==", this.validPhone());
              if (this.validPhone()) {
                return true;
              } else {
                return false;
              }
            }
          } else {
            return false;
          }

        } else {
          if (this.current_tel.toString().length >= 9 && this.current_tel.toString().length <= 30) {
            if ((this.current_tel.toString().includes(substring)) || (this.current_tel.toString().includes(spacestring)) || (this.current_tel.toString().includes(zerochar))) {
              return false;
            } else {
              // console.log("this.validPhone() ==", this.validPhone());
              if (this.validPhone()) {
                return true;
              } else {
                return false;
              }
            }
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    },
    validation_no() {
      if (this.current_add != null) {
        return this.current_add.length >= 1 && this.current_add.length < 50
      } else {
        return false;
      }
    },

    validation_village() {
      if (this.current_village != null) {
        return this.current_village.length >= 1 && this.current_village.length < 50
      } else {
        return false;
      }
    }, validation_build() {
      if (this.current_building != null) {
        return this.current_building.length >= 1 && this.current_building.length < 50
      } else {
        return false;
      }
    },
    validation_road() {
      if (this.current_road != null) {
        return this.current_road.length >= 1 && this.current_road.length < 50
      } else {
        return false;
      }
    },
    validation_soi() {
      if (this.current_lane != null) {
        return this.current_lane.length >= 1 && this.current_lane.length < 50
      } else {
        return false;
      }
    },
    validation_moo() {
      if (this.current_moo != null) {
        return this.current_moo.length >= 1 && this.current_moo.length < 50
      } else {
        return false;
      }
    },
    /* validation_add() {
       if (this.current_address != null) {
         return this.current_address.length >= 10 && this.current_address.length < 500
       } else {
         return false;
       }
     } */

  },
  methods: {
    validEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const thaiCharRegex = /[ก-ฮ]/;
      if (email!=null && email!='' && email!=undefined) {
        if (!emailRegex.test(email)) {
          return false;
        } else if (thaiCharRegex.test(email)) {
          return false;
        } else {
          return true;
        }
      }else{
        return false;
      }
    },
    validFax(fax) {
      // console.log("fax==",fax)
      //() + #
      //var phoneno = /^\(?([0-9]{2})\)?[-]?([0-9]{4})[-]?([0-9]{4})$/; // /^\d{10}$/;  // /^[0-9]\d{2}-\d{3}-\d{4}$/;
      var phoneno_t9 = /^\d{9}$/;
      var phoneno_t10 = /^\d{10}$/;
      var phoneno1 = /^[+]{1}$/;
      var phoneno9 = /^\d{9}$/;
      var phoneno10 = /^\d{10}$/;
      var phoneno11 = /^\d{11}$/;
      var phoneno12 = /^\d{12}$/;
      var phoneno13 = /^\d{13}$/;
      var phoneno14 = /^\d{14}$/;
      var phoneno15 = /^\d{15}$/;
      var phoneno16 = /^\d{16}$/;
      var phoneno17 = /^\d{17}$/;
      var phoneno18 = /^\d{18}$/;
      var phoneno19 = /^\d{19}$/;
      var phoneno20 = /^\d{20}$/;
      var phoneno21 = /^\d{21}$/;
      var phoneno22 = /^\d{22}$/;
      var phoneno23 = /^\d{23}$/;
      var phoneno24 = /^\d{24}$/;
      var phoneno25 = /^\d{25}$/;
      var phoneno26 = /^\d{26}$/;
      var phoneno27 = /^\d{27}$/;
      var phoneno28 = /^\d{28}$/;
      var phoneno29 = /^\d{29}$/;
      var phoneno30 = /^\d{30}$/;
      var number = 0;
      // console.log("xx==", this.chackString(this.current_fax));
      if (fax == '-') {
        // console.log("true=837");
        return true;
      } else {
        if (fax == 'TH') {
          if (fax.match(phoneno_t9) || fax.match(phoneno_t10)) {
            // console.log("true=841");
            return true;
          } else {
            // console.log("false=844");
            return false;
          }
        } else {
          // console.log("string_plus=", this.current_fax);
          var x = "";
          var string_plus = "+";
          var string_open = "(";
          var string_end = ")";
          var string_sharp = "#";
          var have_string = 0;
          if (fax.includes(string_plus) || fax.includes(string_open) ||
            fax.includes(string_end) || fax.includes(string_sharp)) {
            // console.log("t==857");
            x = fax.replace(string_plus, "")
            x = x.replace(string_open, "")
            x = x.replace(string_end, "")
            x = x.replace(string_sharp, "")
            // console.log("x==", x);
            have_string = 1;
            return true;
          } else {
            have_string = 0;
          }

          if (have_string == 1) {
            if (x.match(phoneno9) || x.match(phoneno10) || x.match(phoneno11) || x.match(phoneno12) || x.match(phoneno14)
              || x.match(phoneno15) || x.match(phoneno16) || x.match(phoneno17) || x.match(phoneno18)
              || x.match(phoneno19) || x.match(phoneno20) || x.match(phoneno21) || x.match(phoneno22)
              || x.match(phoneno23) || x.match(phoneno24) || x.match(phoneno25) || x.match(phoneno26)
              || x.match(phoneno27) || x.match(phoneno28) || x.match(phoneno29) || x.match(phoneno30)) {
              // console.log("t==875");
              return true;
            } else {
              // console.log("f==878");
              return false;
            }
          } else {
            if (fax.match(phoneno9) || fax.match(phoneno10) || fax.match(phoneno11) || fax.match(phoneno12) || fax.match(phoneno14)
              || fax.match(phoneno15) || fax.match(phoneno16) || fax.match(phoneno17) || fax.match(phoneno18)
              || fax.match(phoneno19) || fax.match(phoneno20) || fax.match(phoneno21) || fax.match(phoneno22)
              || fax.match(phoneno23) || fax.match(phoneno24) || fax.match(phoneno25) || fax.match(phoneno26)
              || fax.match(phoneno27) || fax.match(phoneno28) || fax.match(phoneno29) || fax.match(phoneno30)) {
              // console.log("t==887");
              return true;
            } else {
              // console.log("f==890");
              return false;
            }
          }
        }
      }

    },
    validPhone() {
      // var phoneno = /^\(?([0-9]{2})\)?[-]?([0-9]{4})[-]?([0-9]{4})$/; // /^\d{10}$/;  // /^[0-9]\d{2}-\d{3}-\d{4}$/;
      var phoneno10 = /^\d{10}$/;
      var phoneno11 = /^\d{11}$/;
      var phoneno12 = /^\d{12}$/;
      var phoneno13 = /^\d{13}$/;
      var phoneno14 = /^\d{14}$/;
      var phoneno15 = /^\d{15}$/;
      var phoneno16 = /^\d{16}$/;
      var phoneno17 = /^\d{17}$/;
      var phoneno18 = /^\d{18}$/;
      var phoneno19 = /^\d{19}$/;
      var phoneno20 = /^\d{20}$/;
      var phoneno21 = /^\d{21}$/;
      var phoneno22 = /^\d{22}$/;
      var phoneno23 = /^\d{23}$/;
      var phoneno24 = /^\d{24}$/;
      var phoneno25 = /^\d{25}$/;
      var phoneno26 = /^\d{26}$/;
      var phoneno27 = /^\d{27}$/;
      var phoneno28 = /^\d{28}$/;
      var phoneno29 = /^\d{29}$/;
      var phoneno30 = /^\d{30}$/;
      if (this.current_tel.match(phoneno10) || this.current_tel.match(phoneno11) || this.current_tel.match(phoneno12) || this.current_tel.match(phoneno13) ||this.current_tel.match(phoneno14)
        || this.current_tel.match(phoneno15) || this.current_tel.match(phoneno16) || this.current_tel.match(phoneno17) || this.current_tel.match(phoneno18)
        || this.current_tel.match(phoneno19) || this.current_tel.match(phoneno20) || this.current_tel.match(phoneno21) || this.current_tel.match(phoneno22)
        || this.current_tel.match(phoneno23) || this.current_tel.match(phoneno24) || this.current_tel.match(phoneno25) || this.current_tel.match(phoneno26)
        || this.current_tel.match(phoneno27) || this.current_tel.match(phoneno28) || this.current_tel.match(phoneno29) || this.current_tel.match(phoneno30)) {
        // console.log("--------true---------",this.current_tel);
        return true;
      } else {
        // console.log("--------false---------",this.current_tel);
        return false;
      }
    },
    getCountry(thaistudent) {
      api
        .getCountryNoThaiPost(thaistudent)
        .then(res => {
          this.countryItems = res.data.data;
          // console.log("res==", res);
        })
        .catch(err => {
          console.log("getCountry", err.toString());
        });
    },
    selectCountryOnchange: function () {
      this.select_country = this.select_country1.COUNTRYID;
      // console.log("select_country==", this.select_country);
      this.current_country_name = this.select_country1.COUNTRYNAME;
      //  api
      //   .getCountryById(this.select_country,this.student.thaistudent)
      //   .then(res => {
      //     this.current_country_name = res.data.data[0].COUNTRYNAME;
      //   })
      //   .catch(err => {
      //     // console.log(2);
      //     console.log("getCountryById", err.toString());
      //   });
    },
    getProvinceAll(thaistudent) {
      api
        .getProvinceAll(thaistudent)
        .then(res => {
          this.provinceItems = res.data.data;
        })
        .catch(err => {

          console.log("getProvince", err.toString());
        });
    },
    getProvinceId(id, thaistudent) {
      api
        .getProvinceById(id, thaistudent)
        .then(res => {
          this.current_province_name = res.data.data[0].PROVINCENAME;
          // console.log("current_province_name", this.current_province_name);
        })
        .catch(err => {

          console.log("getProvince", err.toString());
        });
    },
    getDistrictId(id, thaistudent) {
      api
        .getDistrictByDistrictid(id, thaistudent)
        .then(res => {
          this.current_district_name = res.data.data[0].DISTRICTNAME;
          // console.log("current_district_name", this.current_district_name);
        })
        .catch(err => {

          console.log("getProvince", err.toString());
        });
    },
    getSubDistrictId(id, thaistudent) {
      // console.log("id==",id)
      api
        .getSubDistrictBySubdistricid(id, thaistudent)
        .then(res => {
          this.current_subdistrict_name = res.data.data[0].SUB_DISTRICTNAME;
          // console.log("current_subdistrict_name", this.current_subdistrict_name);
        })
        .catch(err => {

          console.log("getProvince", err.toString());
        });
    },
    onloadDistrictById: async function () {
      api
        .getDistrictByid(this.select_province, this.student.thaistudent)
        .then(res => {
          this.districtItems = res.data.data;
        })
        .catch(err => {
          console.log("onloadDistrictById", err.toString());
        });
    },
    onloadSubDistrictById: async function () {
      api
        .getSubDistrictByid(this.select_district, this.student.thaistudent)
        .then(res => {
          this.subdistrictItems = res.data.data;
        })
        .catch(err => {
          console.log("onloadSubDistrictById", err.toString());
        });
    },
    onloadZipcodeById: async function () {
      api
        .getZipcode(this.select_subdistrict, this.student.thaistudent)
        .then(res => {
          this.current_subdistrict = this.select_subdistrict;
          this.current_zipcode = res.data.data[0].ZIPCODE;
        })
        .catch(err => {
          console.log("onloadZipcodeById", err.toString());
        });
    },
    selectProvinceOnchange: function () {
      this.onloadDistrictById(this.select_province);
      this.getProvinceId(this.select_province, this.thai_student);
      // console.log("select_province981== ", this.select_province);
      this.select_subdistrict = 0;
    },
    selectDistrictOnchange: function () {
      this.current_district = this.select_district;
      // console.log("894== ", this.select_district);
      this.getDistrictId(this.select_district, this.thai_student);
      this.onloadSubDistrictById(this.select_district);
    },
    selectSubDistrictOnchange: function () {
      this.getSubDistrictId(this.select_subdistrict, this.thai_student);
      // console.log("getSubDistrictId==", this.select_subdistrict, this.thai_student);
      this.onloadZipcodeById(this.select_subdistrict);
    },
    getStudentGeneral(studentid) {
      api
        .getStudentGeneral(studentid)
        .then(res => {
          // console.log("getStudentGeneral res== ", res);
          if (res.data.data.length == 1) {

            this.actionStudent = 1;
            var currentSt = res.data.data[0];

            this.current_name = currentSt.STUDENTNAME;
            this.current_surname = currentSt.STUDENTSURNAME;
            this.current_tel = currentSt.CURRENT_TEL;
            this.current_country = currentSt.CURRENT_COUNTRY;
            this.current_email = currentSt.CURRENT_EMAIL;
            this.current_add = currentSt.CURRENT_NO;
            this.current_village = currentSt.CURRENT_VILLAGE;
            this.current_building = currentSt.CURRENT_BUILDING;
            this.current_moo = currentSt.CURRENT_MOO;
            this.current_lane = currentSt.CURRENT_LANE;
            this.current_road = currentSt.CURRENT_ROAD;
            this.current_zipcode = currentSt.CURRENT_ZIPCODE;
            this.select_provinceid = currentSt.CURRENT_PROVINCEID;
            //this.select_district = currentSt.CURRENT_DISTRICT; เอาออกก่อน เดี๋ยวตำบลไม่ขึ้น
            this.current_subdistrict = currentSt.CURRENT_SUBDISTRICT;
            this.current_country = currentSt.CURRENT_COUNTRY;
            if ((this.selected_post == 21) || (this.selected_post == 22)) {
              // console.log("selected_post== ",this.selected_post);
              this.getProvinceAll(this.student.thaistudent);
              this.select_province = currentSt.CURRENT_PROVINCEID;
              // console.log("select_province== ",currentSt.CURRENT_PROVINCEID);
              this.select_district = currentSt.CURRENT_DISTRICT;
              this.onloadDistrictById(this.select_province);
              this.select_subdistrict = currentSt.CURRENT_SUBDISTRICT;
              this.onloadSubDistrictById(this.select_district);
            }
            if ((this.current_province_name != '') && (this.current_province_name != 0) && (this.current_province_name != null) && (this.current_province_name != undefined)) {
              this.getProvinceId(this.select_province, this.student.thaistudent);
            }
            if ((this.current_district_name != '') && (this.current_district_name != 0) && (this.current_district_name != null) && (this.current_district_name != undefined)) {
              // console.log("942== ",this.select_district);
              this.getDistrictId(this.select_district, this.student.thaistudent);
            }
            if ((this.current_subdistrict_name != '') && (this.current_subdistrict_name != 0) && (this.current_subdistrict_name != null) && (this.current_subdistrict_name != undefined)) {
              console.log("getSubDistrictId==", this.select_subdistrict, this.student.thaistudent);
              this.getSubDistrictId(this.select_subdistrict, this.student.thaistudent);
            }

            this.getCountry(this.student.thaistudent);
            this.select_country = currentSt.CURRENT_COUNTRY;
            // this.student.current_country_name=currentSt.CURRENT_COUNTRY_NAME;
            this.current_country_name = currentSt.CURRENT_COUNTRY_NAME;

            // }

          } else {
            this.actionStudent = 0;
          }
          // console.log("getStudentGeneral==", this.actionUpdate);
          return this.actionStudent;
        })
        .catch(err => {
          this.actionStudent = 10;
          console.log("getStudentGeneral", err.toString());
          this.$router.push("/logout");
        });
    },

    getCurrentStudent(student) {
      api
        .getStudentPostById(student)
        .then(res => {
          // console.log(" getCurrentStudent==", res);
          var currentSt = res.data.data[0];
          this.current_paid = res.data.data[0].PAIDAALREADY;
          if (res.data.data.length == 1) {
            this.actionUpdate = 1;

            // if (res.data.data[0].POST_STATUS == null) {
            //   this.actionUpdate = 0;
            //   // console.log("964 getCurrentStudent ไม่มี",this.actionUpdate,res);
            // } else {
            //   this.actionUpdate = 1;
            //   // console.log(" getCurrentStudent มีข้อมูล",this.actionUpdate,res);
            // }
            // console.log("xxx==",this.actionUpdate);
            this.selected_post = currentSt.POST_STATUS;
            // console.log(" this.selected_post ",this.selected_post );

            if ((this.selected_post == 11) || (this.selected_post == null)) {
              this.getStudentGeneral(student.studentid);
            }
            if (this.selected_post == 12) {
              this.current_authorized = currentSt.POST_AUTHORIZED_PERSON;
              this.getStudentGeneral(student.studentid);
            }
            if ((this.selected_post == 21) || (this.selected_post == 22)) {

              this.current_name = currentSt.POST_FIRST_NAME;
              this.current_surname = currentSt.POST_LAST_NAME;
              this.current_add = currentSt.POST_ADD;
              this.getProvinceAll(this.thai_student);
              this.select_province = currentSt.POST_PROVICE;
              // console.log(" select_province==",currentSt.POST_PROVICE);
              this.current_province_name = currentSt.POST_PROVICE_NAME;
              this.onloadDistrictById(this.select_province);
              this.select_district = currentSt.POST_DISTRICT;
              // console.log(" select_district1094==",this.select_district);
              this.current_district_name = currentSt.POST_DISTRICT_NAME;
              this.select_subdistrict = currentSt.POST_TAMBON;
              // console.log("xx==", this.select_district)
              if (this.select_district != '')
                this.onloadSubDistrictById(this.select_district);
              this.current_subdistrict_name = currentSt.POST_TAMBON_NAME;
              this.current_zipcode = currentSt.POST_ZIPCODE;
              this.current_moo = currentSt.POST_MOO;
              this.current_village = currentSt.POST_BAN;
              this.current_building = currentSt.POST_BUILDING;
              this.current_lane = currentSt.POST_SOI;
              this.current_road = currentSt.POST_STREET;
              this.current_tel = currentSt.POST_TEL;
              this.current_tel_home = currentSt.POST_TEL_HOME;
              this.current_fax = currentSt.POST_FAX;
              this.current_email = currentSt.POST_EMAIL;
              this.current_fb = currentSt.POST_FACEBOOK;
            }
            if (this.selected_post == 31) {
              this.current_name = currentSt.POST_FIRST_NAME;
              this.current_surname = currentSt.POST_LAST_NAME;
              this.select_country = currentSt.POST_COUNTRY;
              this.select_country1 = currentSt.POST_COUNTRY_NAME;
              this.current_country_name = currentSt.POST_COUNTRY_NAME;
              // console.log("current_country_name== ",this.current_country_name);
              this.current_add = currentSt.POST_ADD;
              this.current_tel = currentSt.POST_TEL;
              this.current_tel_home = currentSt.POST_TEL_HOME;
              this.current_fax = currentSt.POST_FAX;
              this.current_email = currentSt.POST_EMAIL;
              this.current_fb = currentSt.POST_FACEBOOK;
            }
          } else {
            this.actionUpdate = 0;
            this.getStudentGeneral(this.std_id);
          }
          // console.log(" getCurrentStudent==", this.actionUpdate);
          return this.actionUpdate;
        })
        .catch(err => {
          // console.log("getCurrentStudent 1139", err.toString());
          this.actionUpdate = 10;
          // this.$router.push("/Logout");

        });
    },

    setStudent: function () {
      var studentpost = {};
      studentpost.std_id = this.$store.state.user.studentid;
      studentpost.studentid = this.$store.state.user.studentid;
      studentpost.current_year = 2566;
      studentpost.year = 2566;
      studentpost.thai_student = this.$store.state.user.thaistudent
      studentpost.levelid = this.$store.state.user.levelid;
      studentpost.selected_post = this.selected_post;

      studentpost.current_authorized = "";
      studentpost.current_name = "";
      studentpost.current_surname = "";
      studentpost.current_country = "";
      studentpost.current_country_name = "";
      studentpost.current_add = "";
      studentpost.current_province = "";
      studentpost.current_province_name = "";

      studentpost.current_district = "";
      studentpost.current_district_name = "";
      studentpost.current_subdistrict = "";
      studentpost.current_subdistrict_name = "";
      studentpost.current_zipcode = "";
      studentpost.current_moo = "";
      studentpost.current_village = "";
      studentpost.current_building = "";
      studentpost.current_lane = "";
      studentpost.current_road = "";
      studentpost.current_tel = "";
      studentpost.current_tel_home = "";
      studentpost.current_fax = "";
      studentpost.current_email = "";
      studentpost.current_fb = "";
      if (this.selected_post == 12) {
        studentpost.current_authorized = this.current_authorized;
      }
      if ((this.selected_post == 21) || (this.selected_post == 22)) {

        studentpost.current_name = this.current_name;
        studentpost.current_surname = this.current_surname;
        studentpost.current_country = "41";
        if (this.student.thaistudent == 1) {
          studentpost.current_country_name = "ไทย";
        } else {
          studentpost.current_country_name = "Thailand";
        }
        studentpost.current_add = this.current_add;
        studentpost.current_province = this.select_province;
        // console.log("current_province_name== ", this.current_province_name);
        studentpost.current_province = this.select_province;
        studentpost.current_province_name = this.current_province_name;
        studentpost.current_district = this.select_district;
        studentpost.current_district_name = this.current_district_name;
        studentpost.current_subdistrict = this.select_subdistrict;
        studentpost.current_subdistrict_name = this.current_subdistrict_name;
        studentpost.current_zipcode = this.current_zipcode;
        studentpost.current_moo = this.current_moo;
        studentpost.current_village = this.current_village;
        studentpost.current_building = this.current_building;
        studentpost.current_lane = this.current_lane;
        studentpost.current_road = this.current_road;
        studentpost.current_tel = this.current_tel;
        studentpost.current_tel_home = this.current_tel_home;
        studentpost.current_fax = this.current_fax;
        studentpost.current_email = this.current_email;
        studentpost.current_fb = this.current_fb;
      }
      if (this.selected_post == 31) {
        studentpost.current_name = this.current_name;
        studentpost.current_surname = this.current_surname;
        studentpost.current_country = this.select_country;
        studentpost.current_country_name = this.current_country_name;
        studentpost.current_add = this.current_add;
        studentpost.current_tel = this.current_tel;
        studentpost.current_tel_home = this.current_tel_home;
        studentpost.current_fax = this.current_fax;
        studentpost.current_email = this.current_email;
        studentpost.current_fb = this.current_fb;

      }
      return studentpost;
    },
    checkQuotation(s) {
      var quotation1 = "'";
      var quotation2 = "`";
      if (s.current_fb != '' && s.current_fb != null && s.current_fb != undefined) {
        if (s.current_fb.toString().length > 0) {
          if (s.current_fb.toString().includes(quotation1)) {
            s.current_fb = s.current_fb.replaceAll(quotation1, "''");
          }
          if (s.current_fb.toString().includes(quotation2)) {
            s.current_fb = s.current_fb.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_authorized != '' && s.current_authorized != null && s.current_authorized != undefined) {
        if (s.current_authorized.toString().length > 0) {
          if (s.current_authorized.toString().includes(quotation1)) {
            s.current_authorized = s.current_authorized.replaceAll(quotation1, "''");
          }
          if (s.current_authorized.toString().includes(quotation2)) {
            s.current_authorized = s.current_authorized.replaceAll(quotation2, "''");
          }
        }
      }

      if (s.current_village != '' && s.current_village != null && s.current_village != undefined) {
        if (s.current_village.toString().length > 0) {
          if (s.current_village.toString().includes(quotation1)) {
            s.current_village = s.current_village.replaceAll(quotation1, "''");
          }
          if (s.current_village.toString().includes(quotation2)) {
            s.current_village = s.current_village.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_building != '' && s.current_building != null && s.current_building != undefined) {
        if (s.current_building.toString().length > 0) {
          if (s.current_building.toString().includes(quotation1)) {
            s.current_building = s.current_building.replaceAll(quotation1, "''");
          }
          if (s.current_building.toString().includes(quotation2)) {
            s.current_building = s.current_building.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_road != '' && s.current_road != null && s.current_road != undefined) {
        if (s.current_road.toString().length > 0) {
          if (s.current_road.toString().includes(quotation1)) {
            s.current_road = s.current_road.replaceAll(quotation1, "''");
          }
          if (s.current_road.toString().includes(quotation2)) {
            s.current_road = s.current_road.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_lane != '' && s.current_lane != null && s.current_lane != undefined) {
        if (s.current_lane.toString().length > 0) {
          if (s.current_lane.toString().includes(quotation1)) {
            s.current_lane = s.current_lane.replaceAll(quotation1, "''");
          }
          if (s.current_lane.toString().includes(quotation2)) {
            s.current_lane = s.current_lane.replaceAll(quotation2, "''");
          }
        }
      }

      if (s.current_moo != '' && s.current_moo != null && s.current_moo != undefined) {
        if (s.current_moo.toString().length > 0) {
          if (s.current_moo.includes(quotation1)) {
            s.current_moo = s.current_moo.replaceAll(quotation1, "''");
          }
          if (s.current_moo.toString().includes(quotation2)) {
            s.current_moo = s.current_moo.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_province_name != '' && s.current_province_name != null && s.current_province_name != undefined) {
        if (s.current_province_name.toString().length > 0) {
          if (s.current_province_name.toString().includes(quotation1)) {
            s.current_province_name = s.current_province_name.replaceAll(quotation1, "''");
          }
          if (s.current_province_name.toString().includes(quotation2)) {
            s.current_province_name = s.current_province_name.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_district_name != '' && s.current_district_name != null && s.current_district_name != undefined) {
        if (s.current_district_name.toString().length > 0) {
          if (s.current_district_name.toString().includes(quotation1)) {
            s.current_district_name = s.current_district_name.replaceAll(quotation1, "''");
          }
          if (s.current_district_name.toString().includes(quotation2)) {
            s.current_district_name = s.current_district_name.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_subdistrict_name != '' && s.current_subdistrict_name != null && s.current_subdistrict_name != undefined) {
        if (s.current_subdistrict_name.toString().length > 0) {
          if (s.current_subdistrict_name.toString().includes(quotation1)) {
            s.current_subdistrict_name = s.current_subdistrict_name.replaceAll(quotation1, "''");
          }
          if (s.current_subdistrict_name.toString().includes(quotation2)) {
            s.current_subdistrict_name = s.current_subdistrict_name.replaceAll(quotation2, "''");
          }
        }
      }
      return s;
    },
    getErrorTxt(s) {
      this.current_erorrtxt = "";
      var substring = "--";
      var sub = "-";
      var zerochar = "00000";
      var slash = "/";
      var bracket_open = "(";
      var bracket_close = ")";
      var square = "#";
      var star = "*";
      var space = " ";
      this.numEror = 0;
      var student = this.checkQuotation(s);
      if (this.selected_post == 20) {
        this.numEror = this.numEror + 1;
        this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/จัดส่งทางไปรษณีย์ โดยให้จัดส่งแบบ(โปรดเลือก) " : this.current_erorrtxt + "/By post";
      }
      if (this.selected_post == 12) {

        if ((this.current_authorized == '') || (this.current_authorized == null)) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ระบุชื่อ-นามสกุลผู้รับมอบฉันทะ " : this.current_erorrtxt + "/Please specify";
        }
      }
      if ((this.selected_post == 21) || (this.selected_post == 22)) {
        if ((this.current_name == "None") || (this.current_name == null) || (this.current_name == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ชื่อ" : this.current_erorrtxt + "/Name";
        }
        if ((this.current_surname == "None") || (this.current_surname == null) || (this.current_surname == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/นามสกุล" : this.current_erorrtxt + "/Surname";
        }
        if ((this.select_province == 0) || (this.select_province == null) || (this.select_province == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/จังหวัด" : this.current_erorrtxt + "/Select province";
        }
        if ((this.select_district == 0) || (this.select_district == null) || (this.select_district == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/อำเภอ" : this.current_erorrtxt + "/Select district";
        }
        if ((this.select_subdistrict == 0) || (this.select_subdistrict == null) || (this.select_subdistrict == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ตำบล" : this.current_erorrtxt + "/Select Subdistrict";
        }
        if ((this.current_add == 0) || (this.current_add == null) || (this.current_add == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/บ้านเลขที่" : this.current_erorrtxt + "/Address number";
        }
        if ((this.current_moo == 0) || (this.current_moo == null) || (this.current_moo == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/หมู่" : this.current_erorrtxt + "/Moo";
        }
        if ((this.current_village == 0) || (this.current_village == null) || (this.current_village == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/หมู่บ้าน" : this.current_erorrtxt + "/Village";
        }
        if ((this.current_building == 0) || (this.current_building == null) || (this.current_building == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/อาคาร" : this.current_erorrtxt + "/Building";
        }
        if ((this.current_lane == 0) || (this.current_lane == null) || (this.current_lane == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ซอย" : this.current_erorrtxt + "/Soi";
        }
        if ((this.current_road == 0) || (this.current_road == null) || (this.current_road == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ถนน" : this.current_erorrtxt + "/Road";
        }
        if ((this.current_tel == 0) || (this.current_tel == null) || (this.current_tel == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/โทรศัพท์มือถือ" : this.current_erorrtxt + "/Mobile";
        }
        if (!this.validPhone()) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/โทรศัพท์ ตัวเลขเท่านั้น" : this.current_erorrtxt + "/Phone Number:";
        }
        if ((this.current_tel_home == 0) || (this.current_tel_home == null) || (this.current_tel_home == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/โทรศัพท์บ้าน" : this.current_erorrtxt + "/Home Phone";
        }
        if ((this.current_fax == 0) || (this.current_fax == null) || (this.current_fax == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/Fax" : this.current_erorrtxt + "/Fax";
        }
        if ((this.current_email == 0) || (this.current_email == null) || (this.current_email == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/E-mail" : this.current_erorrtxt + "/E-mail";
        }
        if (!this.validEmail(this.current_email)) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ตรวจสอบอีเมล์" : this.current_erorrtxt + "/Valid email required";
        }
        if ((this.current_fb == 0) || (this.current_fb == null) || (this.current_fb == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/Facebook" : this.current_erorrtxt + "/Facebook";
        }

      }
      if ((this.selected_post == 31)) {
        // console.log("this.select_country",this.select_country);
        if ((this.select_country == "None") || (this.select_country == null) || (this.select_country == '') || (this.select_country == 0) || (this.select_country == 41)) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ประเทศ" : this.current_erorrtxt + "/Country";
        }

        if ((this.current_name == "None") || (this.current_name == null) || (this.current_name == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ชื่อ" : this.current_erorrtxt + "/Name";
        }
        if ((this.current_surname == "None") || (this.current_surname == null) || (this.current_surname == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/นามสกุล" : this.current_erorrtxt + "/Surname";
        }
        if ((this.current_add == 0) || (this.current_add == null) || (this.current_add == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ที่อยู่" : this.current_erorrtxt + "/Address";
        }
        /* if (!this.validPhone()) {
           this.numEror = this.numEror + 1;
           this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/โทรศัพท์ ตัวเลขเท่านั้น " : this.current_erorrtxt + "/Phone Number:";
         }*/
        /*if ((this.current_tel == 0) || (this.current_tel == null) || (this.current_tel == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/โทรศัพท์มือถือ" : this.current_erorrtxt + "/Mobile";
        }*/
        if ((this.current_tel == null) || (this.current_tel == "") || (this.current_tel == undefined)) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/โทรศัพท์ที่ทำงาน" : this.current_erorrtxt + "/Telephone No.";
        } else {
          if (this.current_country == 41) {
            if (this.current_tel != null || this.current_tel != "" || this.current_tel != undefined) {
            if ((this.current_tel.toString().length < 9)) {
              this.numEror = this.numEror + 1;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ประเทศไทย หมายเลขโทรศัพท์มี 9-10 ตัว" : this.current_erorrtxt + "/Phone Number ";
            }
            if (!this.validPhone()) {
              this.numEror = this.numEror + 1;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/โทรศัพท์ที่ทำงาน ไม่เว้นวรรค ไม่มีสัญลักษณ์" : this.current_erorrtxt + "/Phone Number ";
            }
            if (this.current_tel.includes(zerochar)) {
              this.numEror = this.numEror + 1;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/โทรศัพท์" : this.current_erorrtxt + "/Mobile Phone";
            }}
          } else {
            // console.log("eng==", this.select_country);
            if ((this.current_tel.includes(substring) || this.current_tel.includes(sub)) || (this.current_tel.includes(space))
              || (this.current_tel.includes(zerochar)) || (this.current_tel.includes(slash)) || (this.current_tel.includes(bracket_open))
              || (this.current_tel.includes(bracket_close)) || (this.current_tel.includes(square)) || (this.current_tel.includes(star)) ) {
              // console.log("---");
              this.numEror = this.numEror + 1;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/โทรศัพท์ที่ทำงาน /()#*-" : this.current_erorrtxt + "/Telephone /()#*-";
            }
            if (!this.validPhone()) {
              this.numEror = this.numEror + 1;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/โทรศัพท์ที่ทำงาน ไม่เว้นวรรค ไม่มีสัญลักษณ์" : this.current_erorrtxt + "/Phone Number ";
            }
          }

        }

        if ((this.current_tel_home == 0) || (this.current_tel_home == null) || (this.current_tel_home == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/โทรศัพท์บ้าน" : this.current_erorrtxt + "/Home Phone";
        }
        if ((this.current_fax == 0) || (this.current_fax == null) || (this.current_fax == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/Fax" : this.current_erorrtxt + "/Fax";
        }
        if (!this.validEmail(this.current_email)) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/ตรวจสอบอีเมล์" : this.current_erorrtxt + "/Valid email required";
        }
        if ((this.current_email == 0) || (this.current_email == null) || (this.current_email == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/E-mail" : this.current_erorrtxt + "/E-mail";
        }
        if ((this.current_fb == 0) || (this.current_fb == null) || (this.current_fb == '')) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = this.student.thaistudent == "1" ? this.current_erorrtxt + "/Facebook" : this.current_erorrtxt + "/Facebook";
        }
      }


      if (this.numEror == 0) {
        this.dangerModal = false;
      } else {
        this.dangerModal = true;
      }
      student.num_error = this.numEror;
      return student;
    },
    clickPayment() {

      // console.log("xx==");
    },
    onSubmit() {
      var student_post = {};
      student_post = this.setStudent();
      // console.log("student save=", student_post);
      var st = this.getErrorTxt(student_post);
      // console.log("actionUpdate=", this.actionUpdate);
      if (this.numEror == 0) {
        if ((this.actionUpdate == 0) || (this.actionUpdate == 10)) {
          // save
          // console.log("967student save=", student_post);
          this.onCreateData(st);
          ///ให้ form ชำระเงิน
        } else if (this.actionUpdate == 1) {
          // update
          this.onUpdateData(st);
        } else {

        }
      }

    },
    nextPart() {
      // console.log("selected_post==", this.selected_post)
      if (this.selected_post == 11) { //ด้วยตนเอง
        this.$router.push("person");
      } else if (this.selected_post == 12) { //มอบฉันทะ
        this.$router.push("authorized");
      } else if (this.selected_post == 21) {
        // this.$router.push("\Regispost");
        this.$router.push("postdetail");
      } else if (this.selected_post == 22) {
        // this.$router.push("\Regispost");
        this.$router.push("postdetail");
      } else if (this.selected_post == 31) {
        // this.$router.push("Person");
        this.$router.push("postdetail");
      }

      // this.$router.push("\Postdetail");
    },
    onCreateData(student) {
      // console.log("student==", student);
      api
        .postStudentPost(student)
        .then(res => {
          // console.log("res==", res);
          if (res.data.code == 200) {
            this.message = res.message;
            // console.log("insert ผ่าน");
            // this.nextPart();
            this.nextPart();
          }
        })
        .catch(err => {
          console.log("onCreateData", err.toString());
          // this.$router.push("/Logout");
        });
    },
    onUpdateData(student) {
      api
        .updateStudentPost(student)
        .then(res => {
          if (res.data.code == 200) {
            this.message = res.message;
            // console.log("update ผ่าน", res.data.selected_post);
            this.nextPart();
          }
        })
        .catch(err => {
          console.log("onUpdateData error", err.toString());
          // this.$router.push("/Logout");
        })
    },
    getPosttype(columname, thaistudent, start, finish) {
      api
        .getPostTypeBetween(columname, thaistudent, start, finish)
        .then(res => {

          if (start == 11) {
            // console.log("res==", res);
            this.items = res.data.data;

          } else if (start == 21) {
            this.items1 = res.data.data;
          } else if (start == 31) {
            this.items2 = res.data.data;
          }
          // console.log("res==",res);


        })
        .catch(err => {

          console.log("getPosttype", err.toString());
        });
    },
  },
  mounted() {
  },
  created() {
    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/logout");
    } else {
      // this.$router.push("/Dashboard");
    }
    this.student.studentid = this.$store.state.user.studentid;
    this.student.thaistudent = this.$store.state.user.thaistudent;
    this.thai_student = this.$store.state.user.thaistudent;
    this.student.levelid = this.$store.state.user.levelid;
    this.student.year = 2566;
    // console.log("student==",student)
    api.onSetHeader();
    this.actionUpdate = this.getCurrentStudent(this.student);
    this.getPosttype('POST_STATUS', this.student.thaistudent, 11, 20);
    this.getPosttype('POST_STATUS', this.student.thaistudent, 21, 22);
    this.getPosttype('POST_STATUS', this.student.thaistudent, 31, 31);
    this.getCountry(this.student.thaistudent);

    this.getProvinceAll(this.student.thaistudent);

  }
};
</script>
<style>
</style>
